import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {defaultDotFourB} from "../utils/constants";

export const useShareLinksQuery = () => {
    const {
        model: {
            sku,
            title,
            media: {
                images: {
                    dot4b: variantImages
                }
            },
            primaryMedia: {
                images: {
                    dot4b: primaryImages
                }
            }
        }
    } = useProductDetailsQuery();

    const images = [...variantImages, ...primaryImages];

    return {
        sku,
        title,
        image: images.length ? images[0] : defaultDotFourB
    }
}